<template></template>

<script>
import { mapGetters } from 'vuex';
    export default {
        props: {
            containerId: {
                required: true
            }
        },

        data() {
            return {
                loaded: false
            }
        },

        mounted() {
            this.load();

            Event.listen('CookieConsentSettingsSaved', () => this.updateCookieConsent());
        },

        computed: {
            ...mapGetters('general', ['loggedIn', 'user']),
            ...mapGetters('cookieConsent', ['isToggled', 'hasCookie']),
        },

        methods: {
            async load() {
                await this.dataLayer();
                this.injectScript();
            },

            async dataLayer() {
                window._mtm = window._mtm || [];

                var matomoVariables = {
                    loggedIn: this.loggedIn,
                    cookieConsentMarketing: this.isToggled('marketing'),
                    cookieConsentAnalytics: this.isToggled('analytics'),
                }

                if (this.loggedIn) {
                    matomoVariables.userId = this.user.id;
                    matomoVariables.utm = this.user.utm;
                }

                window._mtm.push(matomoVariables);
            },

            async updateCookieConsent() {
                await this.dataLayer();

                window._mtm = window._mtm || [];
                window._mtm.push({'event': 'CookieConsentSettingsSaved'});
            },

            injectScript() {
                if (this.loaded) {
                    return;
                }

                let script = document.createElement('script');

                script.innerHTML = `var _mtm = window._mtm = window._mtm || [];
                _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src='https://analytics.refunder.com/js/container_${this.containerId}.js'; s.parentNode.insertBefore(g,s);`;

                document.body.appendChild(script);

                this.loaded = true;
            }
        }
    }
</script>
